// Versione corrente dei Termini e Condizioni di Servizio.
// AGGIORNARE questa costante ogni volta che il testo delle T&C cambia in modo
// sostanziale (TermsOfServiceModal.tsx): viene registrata a DB al momento
// dell'accettazione (user_profiles.terms_version) come prova di QUALE versione
// l'utente ha accettato. Formato: data ISO della versione del testo.
export const TERMS_VERSION = '2026-10-17';

// Etichetta leggibile mostrata nel modale come "Ultimo aggiornamento".
// MAI usare new Date() per questa data: deve essere la data della versione
// del testo, non la data di visualizzazione.
export const TERMS_VERSION_LABEL = '17 ottobre 2026';

// Chiave sessionStorage usata per trasportare l'accettazione attraverso il
// redirect OAuth (RegisterPage → provider → OAuthCallback → register-oauth-start).
export const TERMS_ACCEPTANCE_STORAGE_KEY = 'flusia_terms_acceptance';
